/*eslint-disable*/
import React, { useEffect, useState } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { NavLink, useHistory } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Icon from "@material-ui/core/Icon";
// core components
import AdminNavbarLinks from "components/Navbars/AdminNavbarLinks.js";
import RTLNavbarLinks from "components/Navbars/RTLNavbarLinks.js";
import { ExerciseMenu, ExerciseSelector } from "components/Exercises";
import { EXERCISE_MODULES } from "../Exercises/exerciseModule";

import IconExpandLess from "@material-ui/icons/ExpandLess";
import IconExpandMore from "@material-ui/icons/ExpandMore";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Collapse from "@material-ui/core/Collapse";

import styles from "assets/jss/material-dashboard-react/components/sidebarStyle.js";
import { useDot } from "../../context/automatonContext";
import { useUser } from "../../context/userContext";
import { useGrammar } from "context/grammarContext";
import { useLoading } from "../../context/Feedback/loadingContext";
import { useAlert } from "../../context/Feedback/alertContext";
import DOT from "../../components/MachineElement/DOT";
import validations from "../../utils/validationsMachine";
import DataService from "services/DataService";
import constantsValidate from "../../constants/Feedback/validationAutomata";
import constants from "../../constants/sideBarOptions";
import constantsNavbar from "../../constants/navbarOptions";
import constantsAutomaton from "../../constants/alertsInputAutomaton";
import systemConstants from "../../constants/system";
import automatonConstants from "../../constants/Automaton/automatonInfo";
import automatonIcon from "../../assets/img/LogoAutomato 1.png";
import grammarIcon from "../../assets/img/LogoGrammar.png";
import frontFrameworks from "assets/img/react.svg";
import backFrameworks from "assets/img/spring.svg";
import { useRouteName } from "hooks";
import "./style.css";
import { padding } from "@mui/system";
import { formatBackDate } from "../../utils/Formatter";
import packageJson from "../../../package.json";
import AutomatoSelector from "../AutomatoSelector/AutomatoSelector";
import { duration } from "@mui/material";
import { validateTransition } from "../../utils/automatonValidator";
import { MACHINE_TYPES } from "../../variables/machineVariables";

const useStyles = makeStyles(styles);

const useStylesButton = makeStyles(() => ({
  root: {
    backgroundColor: "transparent",
    "&:hover": {
      background: "transparent",
    },
    cursor: "not-allowed",
    color: "black",
  },
}));
//PASSAR OS TIPOS DE MAQUINA QUE CADA FUNCAO ACEITA
const algorithmTypeMapping = {
  complete: [MACHINE_TYPES.AF],
  convertAFNDToAFD: [MACHINE_TYPES.AF],
  minimizar: [MACHINE_TYPES.AF],
  regextToAutomata: [MACHINE_TYPES.AF],
  simulate: [
    MACHINE_TYPES.AF,
    MACHINE_TYPES.AP,
    MACHINE_TYPES.ALL,
    MACHINE_TYPES.MT,
  ],
  importDot: [
    MACHINE_TYPES.AF,
    MACHINE_TYPES.AP,
    MACHINE_TYPES.ALL,
    MACHINE_TYPES.MT,
  ],
};

export default function Sidebar(props) {
  const [backVersion, setBackVersion] = useState("");

  const history = useHistory();
  const classes = useStyles();
  const classesBtn = useStylesButton();

  const [open, setOpen] = React.useState(false);
  const [complete, setComplete] = React.useState(false);
  const [openGrammar, setOpenGrammar] = React.useState(false);
  const [openExercises, setOpenExercises] = React.useState(false);
  const [selectorConfig, setSelectorConfig] = React.useState({
    open: false,
    type: null,
  });
  const {
    language,
    credential,
    user,
    setUser,
    setActiveTutorial,
    setCredential,
    isAuth,
    isAdmin,
    setIsAdmin,
  } = useUser();
  const { setAlert, setActiveAtentionClass, activeAtentionClass } = useAlert();
  const {
    setActiveDialogHowToUseGrammar,
    setActiveDialogHistoricalGrammar,
    setActiveDialogImportGrammar,
  } = useGrammar();
  const routeName = useRouteName();
  const [validMachine, setValidMachine] = useState(false);
  const {
    dot,
    setDot,
    createdDate,
    dotName,
    setDotName,
    setCreatedDate,
    setDrawableDot,
    setCurrentAlgorithm,
    arrayElements,
    setActiveDialogRegex,
    machineStates,
    machineTransitions,
    setMachineTransitionsResponse,
    setMachineStatesResponse,
    setResponseAFNDLambda,
    setResponseTableAFNDLambda,
    setResponseTableAFND,
    setResponseTableAFD,
    setResponseTableMinimization,
    setAfndDot,
    setActiveDialogImportDot,
    setActiveDialogHistorical,
    setActiveDialogSimulate,
    setResponseSimulate,
    automatonType,
    setAutomatonType,
    setIsSimulating,
    setSimulationIndex,
    setSimulationPath,
    setIsMultiPathSimulating,
    setCurrentComputationLevel,
  } = useDot();

  const [hasInvalidTransitions, setHasInvalidTransitions] = useState(false);
  let module = null;

  if (selectorConfig.type && EXERCISE_MODULES[selectorConfig.type]) {
    module = EXERCISE_MODULES[selectorConfig.type];
  }
  useEffect(() => {
    if (machineTransitions && automatonType) {
      const hasInvalid = machineTransitions.some(
        (t) => !validateTransition(t.label, automatonType)
      );
      setHasInvalidTransitions(hasInvalid);
    }
  }, [machineTransitions, automatonType]);

  /**
   * Encerra qualquer simulação em andamento e reseta os estados relacionados.
   *
   * Efeitos colaterais:
   * - chama `setIsSimulating(false)` para desativar o modo de simulação;
   * - chama `setSimulationIndex(0)` para retornar ao primeiro passo;
   * - chama `setSimulationPath([])` para limpar o caminho de simulação;
   *
   * O método é defensivo: verifica se os setters existem e estão definidos como
   * funções antes de invocá-los, e envolve as chamadas em um try/catch para
   * evitar que falhas ao encerrar a simulação interrompam a navegação/UX.
   *
   * Uso: chamar quando o usuário interage com o sidebar (troca de rota,
   * abertura de diálogos, etc.) para garantir que a UI de simulação seja fechado.
   *
   * Não possui parâmetros e não retorna valor.
   *
   * @example
   * // dentro de um handler do sidebar
   * stopSimulation();
   */
  const stopSimulation = () => {
    try {
      if (typeof setIsSimulating === "function") {
        setIsSimulating(false);
      }
      if (typeof setSimulationIndex === "function") {
        setSimulationIndex(0);
      }
      if (typeof setSimulationPath === "function") {
        setSimulationPath([]);
      }

      if (typeof setIsMultiPathSimulating === "function") {
        setIsMultiPathSimulating(false);
      }
      if (typeof setCurrentComputationLevel === "function") {
        setCurrentComputationLevel(0);
      }
    } catch (err) {
      console.error("Erro ao encerrar simulação:", err);
    }
  };
  const { setLoading } = useLoading();

  useEffect(() => {
    const fetchVersion = async () => {
      const backEndVersion = await getVersion();
      setBackVersion(backEndVersion);
    };

    fetchVersion();
  }, []);

  function handleClick() {
    stopSimulation();
    if (activeAtentionClass != "vibrar") {
      setActiveAtentionClass("vibrar");
      setTimeout(() => {
        setActiveAtentionClass("");
      }, 5000);
    }
    if (!open && openGrammar) {
      setOpenGrammar(!openGrammar);
    }
    setOpen(!open);
  }
  function handleClickGrammar() {
    stopSimulation();
    if (activeAtentionClass != "vibrar") {
      setActiveAtentionClass("vibrar");
      setTimeout(() => {
        setActiveAtentionClass("");
      }, 5000);
    }
    if (!openGrammar && open) {
      setOpen(!open);
    }
    setOpenGrammar(!openGrammar);
  }
  /**
   * Gerencia a abertura do submenu de exercícios, garantindo que qualquer simulação em andamento seja encerrada e que os submenus de gramática e máquina sejam fechados para evitar conflitos de UI. Além disso, aplica uma classe de atenção para destacar a interação do usuário.
   */
  function handleClickExercises() {
    stopSimulation();
    if (activeAtentionClass !== "vibrar") {
      setActiveAtentionClass("vibrar");
      setTimeout(() => setActiveAtentionClass(""), 5000);
    }
    if (!openExercises) {
      setOpen(false);
      setOpenGrammar(false);
    }
    setOpenExercises(!openExercises);
  }

  const handleOpenSelector = (type) => {
    if (!type) {
      return;
    }

    setSelectorConfig({
      open: true,
      type: type,
    });
  };
  useEffect(() => {
    if (history.location.state?.openSelector) {
      const type = history.location.state.type;
      handleOpenSelector(type);

      history.replace({ ...history.location, state: undefined });
    }
  }, [history.location.state]);
  const toDotLanguage = () => {
    let dot = new DOT(machineStates, machineTransitions);

    dot.toDotLanguage();

    let string = dot.toString();
    // setDot(string);
    return string;
  };
  useEffect(() => {
    let dot = new DOT(machineStates, machineTransitions);
    dot.toDotLanguage();
    const string = dot.toString();
    setValidMachine(validations.isValidMachine(string).valid);
  }, [machineStates, machineTransitions]);

  const beforeSucceedAlgorithm = () => {
    setMachineTransitionsResponse([]);
    setMachineStatesResponse([]);
  };

  function verifyMachineName() {
    if (!dotName || dotName === "") {
      setAlert({
        active: true,
        text: constantsNavbar.alerts.info.defaultName[language],
        color: "warning",
        severity: "info",
      });
      const dateNow = new Date();
      setDotName(formatDate(dateNow));
      return false;
    }

    const nameExists = user.historicalMachine.some(
      (machine) =>
        machine.name === dotName && machine.createdDate !== createdDate
    );

    if (nameExists) {
      setAlert({
        active: true,
        text: constantsNavbar.alerts.info.nameInUse[language],
        color: "danger",
        severity: "error",
      });
      return false;
    }

    return true;
  }
  async function handleSubmitCompleteAutomaton() {
    stopSimulation();
    let data;
    try {
      if (!verifyMachineName()) {
        return;
      }

      data = toDotLanguage();
      setLoading(true);
      setDrawableDot("");
      resetTables();
      const isValid = validations.isValidMachine(data);
      if (isValid.valid) {
        const headers = {
          Authorization: credential,
        };
        const isComplete = await DataService.seeIfCompleteAutomaton(data, {
          headers,
        });
        if (!isComplete.data) {
          const response = await DataService.createCompleteAutomaton(data, {
            headers: {
              Authorization: credential,
            },
          });
          setCurrentAlgorithm("complete");
          beforeSucceedAlgorithm();
          setDrawableDot(response.data);
          setComplete(true);
          afterSucceedSubmitAutomaton(data);
          history.push("/user/responseAutomaton");
        } else {
          setAlert({
            active: true,
            text: constantsAutomaton.infos.complete[language],
            color: "info",
            sevarity: "info",
          });
        }
        setDot(data);
      } else {
        setAlert({
          active: true,
          text:
            isValid.message[language] +
            ", " +
            constantsValidate.validMachine.error.afterMessage[language],
          color: "info",
          sevarity: "info",
        });
        if (isValid.validationError === 1) {
          setDot("");
        }
      }

      setLoading(false);
    } catch (e) {
      setLoading(false);
      setDot(data);
      alert(e);
    }
  }
  async function handleSubmitConvertAFNDToAFDAutomaton() {
    stopSimulation();
    try {
      if (!verifyMachineName()) {
        return;
      }
      const headers = {
        Authorization: credential,
      };
      const data = toDotLanguage();
      setLoading(true);
      setDrawableDot("");
      resetTables();
      const isValid = validations.isValidMachine(data);
      if (isValid.valid) {
        const isAFDAutomaton = await DataService.seeIfAFDAutomaton(data, {
          headers,
        });

        if (!isAFDAutomaton.data) {
          setResponseAFNDLambda(data);
          const isAFNDLambdaAutomaton =
            await DataService.seeIfAFNDLambdaAutomaton(data, { headers });
          if (isAFNDLambdaAutomaton.data) {
            const responseAFNDLambdaTable =
              await DataService.getTransitionTableAFNDLambda(data, {
                headers: {
                  Authorization: credential,
                },
              });
            setResponseTableAFNDLambda(responseAFNDLambdaTable);
            const AFNDAutomaton = await DataService.convertAFNDLambdaToAFND(
              data,
              {
                headers,
              }
            );
            setAfndDot(AFNDAutomaton.data);
            const responseAFNDTable = await DataService.getTransitionTableAFND(
              AFNDAutomaton.data,
              {
                headers: {
                  Authorization: credential,
                },
              }
            );

            setResponseTableAFND(responseAFNDTable);
            const AFDAutomaton = await DataService.convertAFNDtoAFD(
              AFNDAutomaton.data,
              {
                headers,
              }
            );
            const responseAFDTable = await DataService.getTransitionTableAFD(
              AFDAutomaton.data,
              {
                headers: {
                  Authorization: credential,
                },
              }
            );
            beforeSucceedAlgorithm();
            setResponseTableAFD(responseAFDTable);
            setDrawableDot(AFDAutomaton.data);
            setComplete(true);
            setDot(data);
          } else {
            const AFDAutomaton = await DataService.convertAFNDtoAFD(data, {
              headers,
            });
            const responseAFNDTable = await DataService.getTransitionTableAFND(
              data,
              {
                headers: {
                  Authorization: credential,
                },
              }
            );
            beforeSucceedAlgorithm();
            setResponseTableAFND(responseAFNDTable);
            setAfndDot(data);
            const responseAFDTable = await DataService.getTransitionTableAFD(
              AFDAutomaton.data,
              {
                headers: {
                  Authorization: credential,
                },
              }
            );
            setResponseTableAFD(responseAFDTable);
            setDrawableDot(AFDAutomaton.data);
          }
          history.push("/user/responseAutomaton");
        } else {
          setAlert({
            active: true,
            text: constantsAutomaton.infos.AFD[language],
            color: "info",
            sevarity: "info",
          });
        }

        setCurrentAlgorithm("convertNFDAtoFDA");
        setComplete(true);
        setDot(data);
        afterSucceedSubmitAutomaton(data);
      } else {
        setDot("");

        setAlert({
          active: true,
          text:
            isValid.message[language] +
            ", " +
            constantsValidate.validMachine.error.afterMessage[language],
          color: "info",
          sevarity: "info",
        });
      }
      setLoading(false);
    } catch (e) {
      alert(e);
      setLoading(false);
    }
  }
  async function handleSubmitMinimizationAutomaton() {
    stopSimulation();
    let data;
    try {
      data = toDotLanguage();
      setLoading(true);
      setDrawableDot("");
      resetTables();
      const isValid = validations.isValidMachine(data);
      if (isValid.valid) {
        const isCompleteAutomaton = await DataService.seeIfCompleteAutomaton(
          data,
          {
            headers: {
              Authorization: credential,
            },
          }
        );
        if (isCompleteAutomaton.data) {
          const response = await DataService.getMinimazeAutomaton(data, {
            headers: {
              Authorization: credential,
            },
          });
          const tableMinimization = await DataService.getTableMinimization(
            data,
            {
              headers: {
                Authorization: credential,
              },
            }
          );
          beforeSucceedAlgorithm();
          setResponseTableMinimization(tableMinimization);
          setDrawableDot(response.data);
          setComplete(true);
          afterSucceedSubmitAutomaton(data);
          setDot(data);
          setCurrentAlgorithm("minimize");
          history.push("/user/responseAutomaton");
        } else {
          setAlert({
            active: true,
            text: constantsAutomaton.infos.needIsComplete[language],
            color: "info",
            sevarity: "info",
            // icon: ErrorIcon,
          });
        }
      } else {
        setDot("");

        setAlert({
          active: true,
          text:
            isValid.message[language] +
            ", " +
            constantsValidate.validMachine.error.afterMessage[language],
          color: "info",
          sevarity: "info",
          // icon: ErrorIcon,
        });
      }
    } catch (e) {
      alert(e);
    }
    setLoading(false);
  }
  /**
   * Verifica se uma funcionalidade (algoritmo) pode ser aplicada ao tipo de autômato atual.
   * Se a funcionalidade for permitida, executa a função de callback. Caso contrário, exibe um alerta de erro.
   *
   * @param {string} algorithm A chave do algoritmo no mapeamento `algorithmTypeMapping`.
   * @param {function} runFunction A função a ser executada se o algoritmo for compatível.
   */
  const handleCheckAndRunAlgorithm = (algorithm, runFunction) => {
    if (hasInvalidTransitions) {
      setAlert({
        active: true,
        text: `${automatonConstants.transition.error.invalid[language]} ${constantsNavbar.automatonSelector.machineTypes[automatonType][language]}.`,
        color: "warning",
        severity: "warning",
        duration: 5000,
      });
      return;
    }

    const isAllowed = algorithmTypeMapping[algorithm].includes(automatonType);

    if (isAllowed) {
      runFunction();
    } else {
      setAlert({
        active: true,
        text: `"${automatonType}"${automatonConstants.invalidFuncionalityForType[language]}"${constants.algorithms[algorithm][language]}".`,
        color: "danger",
        severity: "error",
        duration: 5000,
      });
    }
  };

  function resetTables() {
    setResponseAFNDLambda({});
    setResponseTableAFNDLambda({});
    setResponseTableAFND({});
    setResponseTableAFD({});
    setResponseTableMinimization({});
    setResponseSimulate({});
  }

  const formatDate = (date) => {
    const pad = (num) => String(num).padStart(2, "0");

    const d = pad(date.getDate());
    const m = pad(date.getMonth() + 1);
    const y = date.getFullYear();
    const hh = pad(date.getHours());
    const mm = pad(date.getMinutes());
    const ss = pad(date.getSeconds());

    return `${d}/${m}/${y}-${hh}:${mm}:${ss}`;
  };

  function nameExistsInList(list, name, ignoreCreatedDate) {
    return list.some(
      (item) => item.name === name && item.createdDate !== ignoreCreatedDate
    );
  }

  function verifyCreatedDate(list, dateToVerify) {
    return list.findIndex((item) => item.createdDate === dateToVerify);
  }
  /**
   * Processa a submissão bem-sucedida de uma automação e atualiza ou cria um histórico da máquina do usuário.
   *
   * @param {Object} dot - Variáveis da máquina que serão salvas ou atualizadas no histórico.
   * @throws {Error} Lança um erro caso ocorra uma falha na requisição ou processamento dos dados.
   *
   * O funcionamento do método:
   * - Verifica se já existe um histórico da máquina com a mesma `createdDate`.
   * - Se existir, atualiza o histórico existente chamando `DataService.updateHistoricalMc`.
   * - Se não existir, cria um novo histórico chamando `DataService.postSaveHistoricalMc`.
   * - Após a requisição bem-sucedida, atualiza `user.historicalMachine` e define `setCreatedDate`.
   * - Exibe um alerta ao usuário indicando se a máquina foi criada ou atualizada com sucesso.
   */
  async function afterSucceedSubmitAutomaton(dot) {
    try {
      let currentDotName = dotName;
      if (!currentDotName) {
        setAlert({
          active: true,
          text: constantsNavbar.alerts.info.defaultName[language],
          color: "warning",
          severity: "info",
        });
        currentDotName = formatDate(new Date());
        setDotName(currentDotName);
      }

      const authorization = {
        headers: { Authorization: credential },
      };

      const param = {
        variables: dot,
        name: currentDotName,
        automatonType: automatonType,
      };

      const existingIndex = verifyCreatedDate(
        user.historicalMachine,
        createdDate
      );

      if (
        nameExistsInList(user.historicalMachine, currentDotName, createdDate)
      ) {
        setAlert({
          active: true,
          text: constantsNavbar.alerts.info.nameInUse[language],
          color: "danger",
          severity: "error",
        });
        return;
      }

      const dateNow = new Date().toISOString();

      if (existingIndex !== -1) {
        const updateResponse = await DataService.updateHistoricalMc(
          user.email,
          param,
          formatBackDate(createdDate),
          authorization
        );

        setUser((prevUser) => {
          const updatedHistoricalMachine = prevUser.historicalMachine.map(
            (entry) => {
              if (entry.createdDate === createdDate) {
                return {
                  ...entry,
                  variables: dot,
                  lastUpdatedDate: dateNow,
                  createdDate: updateResponse.data.createdDate,
                  name: updateResponse.data.name,
                  automatonType: updateResponse.data.automatonType,
                };
              } else {
                return entry;
              }
            }
          );

          return { ...prevUser, historicalMachine: updatedHistoricalMachine };
        });

        setCreatedDate(updateResponse.data.createdDate);
        setDotName(updateResponse.data.name);
        setAutomatonType(updateResponse.data.automatonType);
        setAlert({
          active: true,
          text: constantsAutomaton.infos.updated[language],
          color: "success",
        });
      } else {
        const saveResponse = await DataService.postSaveHistoricalMc(
          user.email,
          param,
          authorization
        );

        const formattedCreatedDate = saveResponse.data.createdDate.slice(0, 23);

        setUser((prevUser) => {
          const updatedHistoricalMachine = [
            {
              variables: dot,
              lastUpdatedDate: dateNow,
              createdDate: formattedCreatedDate,
              name: saveResponse.data.name,
              automatonType: saveResponse.data.automatonType,
            },
            ...prevUser.historicalMachine,
          ];

          return { ...prevUser, historicalMachine: updatedHistoricalMachine };
        });

        setCreatedDate(formattedCreatedDate);
        setDotName(saveResponse.data.name);
        setAutomatonType(saveResponse.data.automatonType);
        setAlert({
          active: true,
          text: constantsAutomaton.infos.create[language],
          color: "success",
        });
      }
    } catch (e) {
      console.error("Error submitting automaton:", e);
    }
  }

  function handleOpenDialogImportDot() {
    stopSimulation();
    setActiveDialogImportDot(true);
  }
  function handleOpenDialogHistorical() {
    stopSimulation();
    setActiveDialogHistorical(true);
  }
  function handleOpenDialogRegex() {
    stopSimulation();
    setActiveDialogRegex(true);
  }
  function activeRoute(routeName) {
    return location.pathname === routeName;
  }
  function returnRouterTo() {
    if (routeName === "Draw" && validMachine) {
      return "/user/responseAutomaton";
    } else {
      return "/user/automaton";
    }
  }
  function handleOpenDialogHistoricalGrammar() {
    setActiveDialogHistoricalGrammar(true);
  }
  function handleChangeRoute(route) {
    // Se houver uma simulação em andamento, encerra-la ao trocar de rota
    try {
      if (typeof setIsSimulating === "function") {
        setIsSimulating(false);
      }
      if (typeof setSimulationIndex === "function") {
        setSimulationIndex(0);
      }
      if (typeof setSimulationPath === "function") {
        setSimulationPath([]);
      }
      if (typeof setIsMultiPathSimulating === "function") {
        setIsMultiPathSimulating(false);
      }
      if (typeof setCurrentComputationLevel === "function") {
        setCurrentComputationLevel(0);
      }
    } catch (err) {
      // não bloquear navegação se houver erro
      console.error("Erro ao tentar encerrar simulação ao mudar de rota:", err);
    }
    if (route == "grammar") {
      handleClickGrammar();
    } else if (route == "automaton") {
      handleClick();
      if (!automatonType && machineStates.length === 0) {
        setAutomatonType(MACHINE_TYPES.AF);
        setAlert({
          active: true,
          text: automatonConstants.transition.info.automatonDefaultSelection[
            language
          ],
          color: "info",
          severity: "info",
          duration: 5000,
        });
      }
    }
    if (isAuth) {
      history.push("/user/" + route);
    }
  }

  function handleOpenDialogImportGrammar() {
    stopSimulation();
    setActiveDialogImportGrammar(true);
  }

  function handleHowToUseGrammarDialog() {
    stopSimulation();
    setActiveDialogHowToUseGrammar(true);
  }
  /**
   * Faz uma rquisição para o back para saber a versão atual do backEnd a ser exibido.
   * @returns Versão do backend atual ou valor padrão definido
   */
  const getVersion = async () => {
    try {
      const storedVersionWithTime = localStorage.getItem("backEndVersion");
      let needFetch = true;

      if (storedVersionWithTime) {
        try {
          const parsedData = JSON.parse(storedVersionWithTime);

          if (
            typeof parsedData.version === "string" &&
            typeof parsedData.timestamp === "number"
          ) {
            needFetch = false;

            const timeToUpdateVersion = 24 * 60 * 60 * 1000;
            if (
              new Date().getTime() - parsedData.timestamp >
              timeToUpdateVersion
            ) {
              needFetch = true;
            } else {
              return parsedData.version;
            }
          }
        } catch (err) {
          needFetch = true;
        }
      }

      if (needFetch) {
        const response = await DataService.version();
        const backEndVersion = response.data;

        if (backEndVersion) {
          const dataToStore = {
            version: backEndVersion,
            timestamp: new Date().getTime(),
          };
          localStorage.setItem("backEndVersion", JSON.stringify(dataToStore));
        }

        return backEndVersion || "unknown";
      }
    } catch (error) {
      localStorage.removeItem("backEndVersion");
      return "unknown";
    }
  };

  const { logo, image } = props;

  var links = (
    <List>
      <ListItem
        button
        className={classNames(classes.itemText, classes.button, {
          [classes.itemTextRTL]: props.rtlActive,
        })}
      >
        <ListItemIcon>
          <div
            style={{
              width: 50,
              display: "flex",
              alignItems: "center",
              minHeight: 61,
            }}
          >
            <svg
              style={{ width: "100%" }}
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
            >
              <path
                fill="#252536"
                d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-.001 5.75c.69 0 1.251.56 1.251 1.25s-.561 1.25-1.251 1.25-1.249-.56-1.249-1.25.559-1.25 1.249-1.25zm2.001 12.25h-4v-1c.484-.179 1-.201 1-.735v-4.467c0-.534-.516-.618-1-.797v-1h3v6.265c0 .535.517.558 1 .735v.999z"
              />
            </svg>
          </div>
        </ListItemIcon>
        <ListItemText
          onClick={() => {
            handleChangeRoute("about");
          }}
          primary={constants.buttonRouter.theProject[language]}
        />
      </ListItem>
      <ListItem
        button
        className={classNames(classes.itemText, classes.button, {
          [classes.itemTextRTL]: props.rtlActive,
        })}
        onClick={() => {
          handleChangeRoute("grammar");
        }}
      >
        <ListItemIcon
          onClick={() => {
            handleChangeRoute("grammar");
          }}
        >
          <div
            style={{
              width: 50,
            }}
          >
            <img
              title={constants.buttonRouter.grammar[language]}
              style={{ width: "100%" }}
              src={grammarIcon}
            />
          </div>
        </ListItemIcon>

        <ListItemText
          onClick={() => {
            handleChangeRoute("grammar");
          }}
          primary={constants.label.grammar[language]}
        />
        {openGrammar ? (
          <IconExpandLess onClick={handleClickGrammar} />
        ) : (
          <IconExpandMore onClick={handleClickGrammar} />
        )}
      </ListItem>
      <Collapse in={openGrammar} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <List component="div" disablePadding>
            <div className={classes.wrapperList}>
              <ListItem
                button
                onClick={() => {
                  isAuth
                    ? handleOpenDialogImportGrammar()
                    : window.open("/login", "_self");
                }}
                className={classNames(classes.itemText, classes.button, {
                  [classes.itemTextRTL]: props.rtlActive,
                })}
              >
                <ListItemText
                  inset
                  primary={constants.algorithms.importGrammar[language]}
                />
              </ListItem>
            </div>
          </List>

          <div className={classes.wrapperList}>
            <ListItem
              button
              onClick={() => {
                isAuth
                  ? handleOpenDialogHistoricalGrammar()
                  : window.open("/login", "_self");
              }}
              className={classNames(classes.itemText, classes.button, {
                [classes.itemTextRTL]: props.rtlActive,
              })}
            >
              <ListItemText inset primary={constants.historic[language]} />
            </ListItem>
          </div>
          <div className={classes.wrapperList}>
            <ListItem
              onClick={() => {
                handleHowToUseGrammarDialog();
              }}
              button
              disabled={
                isAuth ? (routeName === "grammar" ? false : true) : true
              }
              className={classNames(classes.itemText, classes.button, {
                [classes.itemTextRTL]: props.rtlActive,
              })}
            >
              <ListItemText inset primary={constants.howToUse[language]} />
            </ListItem>
          </div>
        </List>
      </Collapse>
      <ListItem
        button
        className={classNames(classes.itemText, classes.button, {
          [classes.itemTextRTL]: props.rtlActive,
        })}
        onClick={() => {
          handleChangeRoute("automaton");
        }}
      >
        <ListItemIcon
          onClick={() => {
            handleChangeRoute("automaton");
          }}
        >
          <div
            style={{
              width: 50,
            }}
          >
            <img
              title={constants.buttonRouter.machine[language]}
              style={{ width: "100%" }}
              src={automatonIcon}
            />
          </div>
        </ListItemIcon>

        <ListItemText
          onClick={() => {
            handleChangeRoute("automaton");
          }}
          primary={constants.label.machine[language]}
        />
        {open ? (
          <IconExpandLess onClick={handleClick} />
        ) : (
          <IconExpandMore onClick={handleClick} />
        )}
      </ListItem>

      {routeName === "Draw" && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className={classes.wrapperList}>
              <ListItem
                button
                className={classNames(
                  (!validMachine || hasInvalidTransitions) && classesBtn.root,
                  classes.itemText,
                  classes.button,
                  {
                    [classes.itemTextRTL]: props.rtlActive,
                  }
                )}
                onClick={() => {
                  isAuth
                    ? handleCheckAndRunAlgorithm(
                        "complete",
                        handleSubmitCompleteAutomaton
                      )
                    : window.open("/login", "_self");
                }}
              >
                <ListItemText
                  className={classNames(
                    (!validMachine || hasInvalidTransitions) && classesBtn.root
                  )}
                  inset
                  primary={constants.algorithms.complete[language]}
                />
              </ListItem>
              <ListItem
                button
                disabled={isAuth ? (routeName === "Draw" ? false : true) : true}
                // className="bt-afnd"
                className={classNames(
                  (!validMachine || hasInvalidTransitions) && classesBtn.root,
                  classes.itemText,
                  classes.button,
                  {
                    [classes.itemTextRTL]: props.rtlActive,
                  }
                )}
                onClick={() => {
                  handleCheckAndRunAlgorithm(
                    "convertAFNDToAFD",
                    handleSubmitConvertAFNDToAFDAutomaton
                  );
                }}
              >
                <ListItemText
                  className={classNames(
                    (!validMachine || hasInvalidTransitions) && classesBtn.root
                  )}
                  inset
                  primary={constants.algorithms.convertAFNDToAFD[language]}
                />
              </ListItem>
              <ListItem
                button
                className={classNames(
                  (!validMachine || hasInvalidTransitions) && classesBtn.root,
                  classes.itemText,
                  classes.button,
                  {
                    [classes.itemTextRTL]: props.rtlActive,
                  }
                )}
                disabled={isAuth ? (routeName === "Draw" ? false : true) : true}
                onClick={() => {
                  handleCheckAndRunAlgorithm(
                    "minimizar",
                    handleSubmitMinimizationAutomaton
                  );
                }}
              >
                <ListItemText
                  className={classNames(
                    (!validMachine || hasInvalidTransitions) && classesBtn.root
                  )}
                  inset
                  primary={constants.algorithms.minimizar[language]}
                />
              </ListItem>
              <ListItem
                onClick={() => {
                  handleCheckAndRunAlgorithm("regextToAutomata", () =>
                    handleOpenDialogRegex()
                  );
                }}
                disabled={isAuth ? (routeName === "Draw" ? false : true) : true}
                button
                className={classNames(classes.itemText, classes.button, {
                  [classes.itemTextRTL]: props.rtlActive,
                })}
              >
                <ListItemText
                  inset
                  primary={constants.algorithms.regextToAutomata[language]}
                />
              </ListItem>
              <ListItem
                button
                disabled={isAuth ? (routeName === "Draw" ? false : true) : true}
                className={classNames(
                  (!validMachine || hasInvalidTransitions) && classesBtn.root,
                  classes.itemText,
                  classes.button,
                  {
                    [classes.itemTextRTL]: props.rtlActive,
                  }
                )}
                onClick={() => {
                  handleCheckAndRunAlgorithm("simulate", () =>
                    setActiveDialogSimulate(true)
                  );
                }}
              >
                <ListItemText
                  className={classNames(
                    (!validMachine || hasInvalidTransitions) && classesBtn.root
                  )}
                  inset
                  primary={constants.algorithms.simulate[language]}
                />
              </ListItem>
              <ListItem
                onClick={() => {
                  handleOpenDialogImportDot();
                }}
                disabled={isAuth ? (routeName === "Draw" ? false : true) : true}
                button
                className={classNames(classes.itemText, classes.button, {
                  [classes.itemTextRTL]: props.rtlActive,
                })}
              >
                <ListItemText
                  inset
                  primary={constants.algorithms.importDot[language]}
                />
              </ListItem>
              <ListItem
                onClick={() => {
                  setActiveTutorial(true);
                }}
                disabled={isAuth ? (routeName === "Draw" ? false : true) : true}
                button
                className={classNames(classes.itemText, classes.button, {
                  [classes.itemTextRTL]: props.rtlActive,
                })}
              >
                <ListItemText inset primary={constants.howToUse[language]} />
              </ListItem>
              <ListItem
                onClick={() => {
                  handleOpenDialogHistorical();
                }}
                button
                disabled={isAuth ? (routeName === "Draw" ? false : true) : true}
                className={classNames(classes.itemText, classes.button, {
                  [classes.itemTextRTL]: props.rtlActive,
                })}
              >
                <ListItemText inset primary={constants.historic[language]} />
              </ListItem>
            </div>
          </List>
        </Collapse>
      )}
      <ExerciseMenu
        classes={classes}
        language={language}
        constants={constants}
        props={props}
        isOpen={openExercises}
        toggleMenu={handleClickExercises}
        onOpenSelector={handleOpenSelector}
      />
      {isAdmin && (
        <ListItem
          button
          className={classNames(classes.itemText, classes.button, {
            [classes.itemTextRTL]: props.rtlActive,
          })}
        >
          <ListItemIcon>
            <div
              style={{
                width: 50,
                display: "flex",
                alignItems: "center",
                minHeight: 61,
              }}
            >
              <svg
                fill="#000000"
                xmlns="http://www.w3.org/2000/svg"
                style={{ width: "100%" }}
                width="40"
                height="40"
                viewBox="0 0 128 128"
              >
                <path d="M 33.5 9 C 26.3 9 20.5 14.8 20.5 22 L 20.5 102 C 20.5 109.2 26.3 115 33.5 115 L 94.5 115 C 101.7 115 107.5 109.2 107.5 102 L 107.5 22 C 107.5 14.8 101.7 9 94.5 9 L 33.5 9 z M 33.5 15 L 94.5 15 C 98.4 15 101.5 18.1 101.5 22 L 101.5 102 C 101.5 105.9 98.4 109 94.5 109 L 33.5 109 C 29.6 109 26.5 105.9 26.5 102 L 26.5 22 C 26.5 18.1 29.6 15 33.5 15 z M 33.5 22 L 33.5 37 L 94.5 37 L 94.5 22 L 33.5 22 z M 37.5 51 C 35.8 51 34.5 52.3 34.5 54 C 34.5 55.7 35.8 57 37.5 57 L 88.5 57 C 90.2 57 91.5 55.7 91.5 54 C 91.5 52.3 90.2 51 88.5 51 L 37.5 51 z M 37.5 66 C 35.8 66 34.5 67.3 34.5 69 C 34.5 70.7 35.8 72 37.5 72 L 88.5 72 C 90.2 72 91.5 70.7 91.5 69 C 91.5 67.3 90.2 66 88.5 66 L 37.5 66 z M 37.5 81 C 35.8 81 34.5 82.3 34.5 84 C 34.5 85.7 35.8 87 37.5 87 L 64 87 C 65.7 87 67 85.7 67 84 C 67 82.3 65.7 81 64 81 L 37.5 81 z" />
              </svg>
            </div>
          </ListItemIcon>
          <ListItemText
            onClick={() => {
              handleChangeRoute("reports");
            }}
            primary={constants.buttonRouter.report[language]}
          />
        </ListItem>
      )}
    </List>
  );
  var brand = (
    <div className={classes.logo}>
      <a
        href="/user/automaton"
        className={classNames(classes.logoLink, {
          [classes.logoLinkRTL]: props.rtlActive,
        })}
      >
        <div className={classes.logoImage}>
          <img src={logo} alt="logo" className={classes.img} />
        </div>
      </a>
    </div>
  );
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const id = open ? "simple-popover" : undefined;
  return (
    <div>
      <Hidden mdUp implementation="css">
        <Drawer
          variant="temporary"
          anchor={props.rtlActive ? "left" : "right"}
          open={props.open}
          classes={{
            paper: classNames(classes.drawerPaper, {
              [classes.drawerPaperRTL]: props.rtlActive,
            }),
          }}
          onClose={props.handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>
            {props.rtlActive ? <RTLNavbarLinks /> : null} {links}
          </div>
        </Drawer>
      </Hidden>
      <Hidden smDown implementation="css">
        {/* sidebar propriamente dita */}
        <Drawer
          anchor={props.rtlActive ? "right" : "left"}
          variant="permanent"
          open
          classes={{
            paper: classNames(classes.drawerPaper, {
              [classes.drawerPaperRTL]: props.rtlActive,
            }),
          }}
        >
          {brand}
          <div className={` ${classes.sidebarWrapper}`}>
            {(routeName === "automaton" ||
              routeName === "responseAutomaton") && <AutomatoSelector />}

            {links}
          </div>
          <div className="footer-sidebar">
            <List
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                padding: "16px 0",
              }}
            >
              <ListItem
                style={{
                  whiteSpace: "nowrap",
                  padding: "4px 0",
                  display: "flex",
                  alignItems: "center",
                }}
                className={classNames(classes.inlineBlock, classes.block)}
              >
                <img
                  alt="React Logo"
                  src={frontFrameworks}
                  width="30"
                  style={{ marginRight: 8 }}
                />
                <span>
                  {systemConstants.system.version[language]}
                  {packageJson.version}
                </span>
              </ListItem>

              <ListItem
                style={{
                  whiteSpace: "nowrap",
                  padding: "4px 0",
                  display: "flex",
                  alignItems: "center",
                }}
                className={classNames(classes.inlineBlock, classes.block)}
              >
                <img
                  alt="Spring Boot Logo"
                  src={backFrameworks}
                  width="30"
                  style={{ marginRight: 8 }}
                />
                <span>
                  {systemConstants.system.version[language]}
                  {backVersion}
                </span>
              </ListItem>
            </List>
          </div>
          {image !== undefined ? (
            <div className={`testee ${classes.background}`} />
          ) : null}
        </Drawer>
      </Hidden>
      {selectorConfig.open && selectorConfig.type && (
        <ExerciseSelector
          open={selectorConfig.open}
          type={selectorConfig.type}
          isAdmin={isAdmin}
          language={language}
          credential={credential}
          setAutomatonType={setAutomatonType}
          onClose={() => setSelectorConfig({ ...selectorConfig, open: false })}
          onSelect={(id) => {
            setSelectorConfig({ ...selectorConfig, open: false });

            if (!module) {
              console.error(
                "Sidebar - Tipo inválido na navegação:",
                selectorConfig.type
              );
              return;
            }

            history.push(
              `/user/${module.route}?exerciseId=${id}&type=${selectorConfig.type}`
            );
          }}
        />
      )}
    </div>
  );
}
Sidebar.propTypes = {
  rtlActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  bgColor: PropTypes.oneOf(["purple", "blue", "green", "orange", "red"]),
  logo: PropTypes.string,
  image: PropTypes.string,
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  open: PropTypes.bool,
};
